import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './LegalConsent.css';

const copy = {
  en: {
    login: 'By signing in, you agree to the',
    register: 'By creating an account, you agree to the',
    acknowledge: 'and acknowledge the',
    terms: 'Terms of Use',
    privacy: 'Privacy Policy',
    cookies: 'Cookie Policy',
    suffix: 'Your training data will be handled as described in these policies.'
  },
  ru: {
    login: 'Входя в систему, вы принимаете',
    register: 'Создавая учётную запись, вы принимаете',
    acknowledge: 'и подтверждаете ознакомление с документами',
    terms: 'Условия использования',
    privacy: 'Политика конфиденциальности',
    cookies: 'Политика использования файлов cookie',
    suffix: 'Данные о ваших занятиях обрабатываются в соответствии с этими документами.'
  },
  uz: {
    login: 'Tizimga kirish orqali siz',
    register: 'Hisob yaratish orqali siz',
    acknowledge: 'hamda quyidagi hujjatlar bilan tanishganingizni tasdiqlaysiz:',
    terms: 'Foydalanish shartlariga',
    privacy: 'Maxfiylik siyosati',
    cookies: 'Cookie fayllari siyosati',
    suffix: 'Mashg‘ulot ma’lumotlaringiz ushbu siyosatlarga muvofiq qayta ishlanadi.'
  }
};

export default function LegalConsent({ variant = 'login' }) {
  const { language } = useLanguage();
  const text = copy[language] || copy.en;

  return (
    <p className="legal-consent">
      {text[variant]} <Link to="/legal/terms">{text.terms}</Link>{' '}
      {text.acknowledge} <Link to="/legal/privacy">{text.privacy}</Link>{' '}
      {language === 'uz' ? 'va ' : language === 'ru' ? 'и ' : 'and '}
      <Link to="/legal/cookies">{text.cookies}</Link>.
      {variant === 'register' && <> {text.suffix}</>}
    </p>
  );
}
